import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=49edb39e&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edb39e",
  null
  
)

export default component.exports